import { FormFields } from '../enums'

// ----------------------------------------------------------------------

/**
 * State object
 * @typedef State
 * @property {string} firstName
 * @property {string} lastName
 * @property {string} email
 * @property {string} dealershipAddress
 * @property {string} phoneNumber
 * @property {{value: string, label: string}} dealershipState
 * @property {string} dealershipZipCode
 * @property {string} dealershipCity
 * @property {string} dealershipName
 */

// ----------------------------------------------------------------------

/**
 * Initial State
 * @type State
 */
export const initialState = {
  [FormFields.FirstName]: '',
  [FormFields.LastName]: '',
  [FormFields.Email]: '',
  [FormFields.Address]: '',
  [FormFields.State]: '',
  [FormFields.ZipCode]: '',
  [FormFields.City]: '',
  [FormFields.PhoneNumber]: '',
  [FormFields.DealershipName]: '',
}

/**
 * Form index
 * @param {State} state
 * @param {object} action
 * @returns {State}
 */
export const reducer = (state, action) => ({
  ...state,
  ...action.payload,
})
